import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login-email-field',
  templateUrl: './login-email-field.component.html',
  styleUrls: ['./login-email-field.component.css']
})
export class LoginEmailFieldComponent {
  @Input() form: FormGroup;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/login/login-form/login-email-field/login-email-field.component.ts